import Vue from 'vue' // 引入vue实例
import VueI18n from 'vue-i18n' // 引入vue-i18n多语言包

Vue.use(VueI18n) // vue使用vue-i18n

const DEFAULT_LANG = 'en' // 默认语言
// const LOCALE_KEY = 'DemoLanguage' // localStorage来存放的key，名字随便定，接下来会用到。

// const locales = { // 引入zh.json以及en.json
//   zh: require('./zh.json'),
//   en: require('./en.json')
// }
// 异步加载 zh.json 文件
fetch('https://s2.sonkwostatic.cn/ceasia_hk/js/lang/zh.json')
  .then(response => response.json())
  .then(zhData => {
    i18n.setLocaleMessage('zh', zhData)
  })

// 异步加载 en.json 文件
fetch('https://s2.sonkwostatic.cn/ceasia_hk/js/lang/en.json')
  .then(response => response.json())
  .then(enData => {
    i18n.setLocaleMessage('en', enData)
  })

const i18n = new VueI18n({ // 创建带有选项的 VueI18n 实例
  // locale: DEFAULT_LANG, // 语言标识，
  locale: DEFAULT_LANG || 'en', // localStorage.getItem('locale') || 'zh', // 读取locale中的值 zh
  messages: {},
  fallbackLocale: 'en', // 如果在message中找不到相应的键值将回退到原本的语言
  formatFallbackMessages: true // 如果在message中找不到相应的键值将回退到原本的语言

})
// 国际化
// export const setup = lang => { //切换语言的函数，lang为语言标识，en或者zh
//   // 在此判断lang的值，如果未定义，则让lang默认为DEFAULT_LANG，目的是为了让用户在未选择语言的时候默认为英文。
//   if (lang == undefined) {
//     lang = window.localStorage.getItem(LOCALE_KEY)
//     if (locales[lang] == undefined) {
//       lang = DEFAULT_LANG
//     }
//   } // 若lang有值，那么存入localStorage中，key为LOCALE_KEY,value为lang。
//   window.localStorage.setItem(LOCALE_KEY, lang)
//   Object.keys(locales).forEach(item => {
//     document.body.classList.remove('lang-${item}')
//   })
//   document.body.classList.add('lang-${lang}')
//   document.body.setAttribute('lang', lang)

//   Vue.config.lang = lang
//   i18n.locale = lang
// }

// setup()
export default i18n



// WEBPACK FOOTER //
// ./src/assets/lang/lang.js